import Reveal, { Eyebrow } from "@/components/Reveal";
import { MapleMark } from "@/components/MapleMark";
import { SITE } from "@/config/site";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1449247709967-d4461a6a6103?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBtaW5pbWFsJTIwY2xlYW4lMjBvZmZpY2UlMjBkZXNrJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4OTE3ODU4OHww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-12 lg:px-8">
        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>About Postings</Eyebrow>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="mt-5 font-cabinet text-4xl font-extrabold tracking-tighter sm:text-5xl">
              Practical, dependable bookkeeping &amp; payroll.
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="mt-6 space-y-4 leading-relaxed text-slate-600">
              <p>
                Postings Inc. was created to give businesses practical, dependable bookkeeping
                and payroll support. Our team brings experience in bookkeeping, accounting
                systems, payroll, QuickBooks, financial reporting and business operations.
              </p>
              <p>
                We work with businesses of different sizes and industries, while maintaining the
                personal service you&apos;d expect from a local professional firm.
              </p>
              <p>
                Postings operates alongside the broader Ford Group organization while maintaining
                its focus on bookkeeping and payroll services.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-7 flex items-center gap-2 text-sm font-semibold text-brand">
              <MapleMark className="h-4 w-4 text-accent" />
              Proudly serving {SITE.regions}
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-6">
          <Reveal delay={0.1}>
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="A warm, organized workspace at the Postings Inc. office"
                className="aspect-[4/3] w-full rounded-3xl object-cover shadow-ambient"
                loading="lazy"
              />
              <div className="absolute bottom-5 left-5 rounded-2xl bg-white/85 px-5 py-3 shadow-hover backdrop-blur-xl" data-testid="about-office-chip">
                <p className="text-xs font-bold text-ink">Newmarket, Ontario</p>
                <p className="mt-0.5 text-xs text-slate-500">Tuesday–Thursday 9–5 · Mon &amp; Fri by appointment</p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
